export default __webpack_public_path__ + "static/media/ditanic.ee5c7deb.png";